@let iframeState = iframeState$ | async;

@if (iframeState !== WidgetStatus.ERROR) {
  <div class="rounded-large border white-bg mr-large-b">
    @if (iframeState === WidgetStatus.LOADING || iframeState === WidgetStatus.INITIAL) {
      <fcom-loader class="loader" [loaderType]="LoaderTheme.EMBEDDED"></fcom-loader>
    }
    <div id="krazyglue-embedded-wrapper" referrerpolicy="origin-when-cross-origin">
      <!-- The embedded attach module iframe will be loaded here. -->
    </div>
  </div>
}
